<script lang="ts">
	import { LabelList } from '@Shelly/shelly-design-system';
		import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	import { status_configurator } from '../../../helpers/device_data_helpers';
	import {
		get_gen_2_component_channel_structure,
		is_gen_2,
		real_id,
	} from '../../../helpers/interface_helpers';
	import TimerRemaining from '../../../components/TimerRemaining/TimerRemaining.svelte';
	import { getCustomizeLabelList } from 'src/components/DevicesSettings/CustomizeDeviceWizard/customize-device-wizard-helpers';
	import type { Device } from 'src/types/Device';

	export let device: Device;

	let timerLabels: Record<string, any> = {};
	$: statusStore = getDeviceStatus(device.id);
	$: status = $statusStore;
	$: settingsStore = getDeviceSettings(device.id);
	$: settings = $settingsStore;
	$: statuses = status_configurator(status, device, settings);
	$: labelList = getCustomizeLabelList(device, statuses);
	$: combinedLabelList = [...Object.values(timerLabels), ...labelList];

	// if (device.category !== 'sensor') {
	$: emeter_timer =
		!is_gen_2(device) && device.category === 'emeter' && status?.['relays']?.[0].has_timer;
	$: gen_1_timer =
		!is_gen_2(device) &&
		device.category !== 'emeter' &&
		status?.[device.category + 's']?.[device.channel].has_timer;
	$: gen_2_timer =
		is_gen_2(device) &&
		typeof status?.[`${get_gen_2_component_channel_structure(device)}`]?.timer_started_at !==
			'undefined';
	// }
</script>

{#if gen_1_timer}
	{#key status[device.category + 's'][device.channel].timer_started}
		<TimerRemaining timerKey="gen1_main" {device} {status} {settings} bind:timerLabels />
	{/key}
{/if}
{#if emeter_timer}
	{#key status['relays'][0].timer_started}
		<TimerRemaining timerKey="gen1_emeter" {device} {status} {settings} bind:timerLabels />
	{/key}
{/if}
{#if gen_2_timer}
	{#key status[get_gen_2_component_channel_structure(device)].timer_started_at}
		<TimerRemaining timerKey="gen2_main" {device} {status} {settings} bind:timerLabels />
	{/key}
{/if}

<!-- Render ONCE with all timers stacked first, then original labels -->
<LabelList labelList={combinedLabelList} type="default" slot="main" size="m" />
